import { BuiltInComponents } from 'craft/constants';
import { useCraftPropsContext } from 'craft/contexts';
import { useEditor, useMultiNodes } from 'craft/hooks';

export const useGenerateInteractionLabelName = (nodeIds: string[]) => {
  const { type } = useMultiNodes(nodeIds);
  const { query } = useEditor();
  const { contentMetadata } = useCraftPropsContext();

  return (actionType: string, randomId?: string) => {
    const { displayName, name } =
      type === BuiltInComponents.Multiple
        ? { displayName: BuiltInComponents.Multiple, name: undefined }
        : {
            displayName: query.node(nodeIds[0]).displayName(),
            name: query.node(nodeIds[0]).get()?.data?.custom.displayName,
          };
    const contentName = contentMetadata?.name || 'Interaction';

    const optionalNames = [contentName, name || randomId || nodeIds[0]].filter(
      (e) => !!e && e.length > 0,
    );

    return `${displayName || 'Native'}. ${actionType}. ${optionalNames.join('. ')}`;
  };
};
